import { Component } from '@angular/core';

@Component({
  selector: 'ui-fullscreen-body',
  template: '<div class="ui-fullscreen-body"><ng-content></ng-content></div>',
  styleUrls: [ './fullscreen-body.component.less' ],
})
export class UiFullscreenBodyComponent {}
